import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ForgotPasswordForm from "../forms/ForgotPasswordForm";
import LinkMessage from "../messages/LinkMessage";
import { resetPasswordRequest } from "../../actions/auth";
import { Grid, Message, Card, Header, List } from "semantic-ui-react";

class ForgotPasswordPage extends React.Component {
  state = {
    message_sent: false,
  };

  submit = (data) =>
    resetPasswordRequest(data).then(() => {
      this.setState({
        message_sent: true,
      });
    });

  render() {
    const { message_sent } = this.state;
    return (
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={5}></Grid.Column>
        <Grid.Column
          className="logginSeparation"
          mobile={16}
          tablet={16}
          computer={6}
        >
          {!message_sent && (
            <Card fluid={true}>
              <Message attached>
                <Header size="medium">Restablecer contraseña </Header>
              </Message>
              <Card.Content>
                <ForgotPasswordForm submit={this.submit} />
              </Card.Content>
              <Message attached="bottom" warning>
                <List horizontal>
                  <List.Item>
                    <Link to="/login">Inicie su sesión</Link>
                  </List.Item>
                </List>
              </Message>
            </Card>
          )}
          {message_sent && (
            <LinkMessage
              header="Correo enviado exitosamente"
              text="Un correo electrónico fue enviado con un enlace para modificar su contraseña"
              link=""
              page=""
            />
          )}
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={5}></Grid.Column>
      </Grid>
    );
  }
}

ForgotPasswordPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default ForgotPasswordPage;
